export default __webpack_public_path__ + "static/IRAN-5b7f0ea4972acd4bf0d802d89fe73917.svg";